<template>
  <v-app>
    <v-main>
      <Spinner v-if="loading" class="full-view" />
      <div v-else class="full-view">
        <BackgroundGradiant />
        <router-view />
      </div>
    </v-main>
  </v-app>
</template>

<script setup lang="ts">
import BackgroundGradiant from '@shared/components/UIElements/BackgroundGradiant.vue';
import { redirectIfConnected } from '@/utils/redirect';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Spinner from '@shared/components/UIElements/Spinner.vue';

const loading = ref(true);
const route = useRoute();
const router = useRouter();

onMounted(async () => {
  await router.isReady();

  // These pages read the session themselves instead of leaving for the application.
  if (route.meta.handlesSession) {
    loading.value = false;
  } else {
    // Show the page unless the browser is leaving; an unverified session stays to verify.
    redirectIfConnected()
      .then((leaving) => {
        loading.value = leaving;
      })
      .catch(() => {
        // User is not connected, do nothing
        loading.value = false;
      });
  }
});
</script>

<style lang="scss">
@import '@shared/css/main';
@import '@/css/main';
</style>
